import { PartnerModel } from '@app/core/models/partner/partner.model';

/** Отображаемое имя партнера: у агента и самозанятого нет юр. названия — берем ФИО из документа */
export function partnerDisplayName(
  partner: Pick<PartnerModel, 'id' | 'legalName' | 'tradeName' | 'agent' | 'selfEmployed'> | null | undefined
): string {
  if (!partner) return '';
  return (
    partner.tradeName ||
    partner.legalName ||
    partner.agent?.fullName ||
    partner.selfEmployed?.fullName ||
    partner.id
  );
}

/** Только ТОО/ИП могут владеть сетями, магазинами, подкатегориями, сериями, пакетами и правилами сети */
export function isCompanyPartner(partner: Pick<PartnerModel, 'partnerType'> | null | undefined): boolean {
  return partner?.partnerType === 'TOO' || partner?.partnerType === 'IP';
}
